import React, {useEffect, useState} from 'react'
import db from '../../../../../services/firebase'
import {
  collection,
  doc,
  onSnapshot,
  updateDoc,
  getDoc,
  addDoc,
  serverTimestamp,
} from 'firebase/firestore'
import {useAuth} from '../../../../modules/auth'
import Drawer from 'react-modern-drawer'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import Input from 'app/components/Input'

const EditAudit = ({isOpen, onClose, auditID}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [activeFrameworks, setActiveFrameworks] = useState<any[]>([])
  const {currentUser} = useAuth()
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})
  const [frameworks, setFrameworks] = useState<string[]>([])
  const [owner, setOwner] = useState('')
  const [organization, setOrganization] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [auditTitle, setAuditTitle] = useState('')

  useEffect(() => {
    getAudits()
  }, [auditID])

  const getAudits = () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      if (!tenantId || !auditID) {
        return
      }
      const tenantRef = doc(db, 'tenants', tenantId)
      const PolicyRef = collection(tenantRef, 'audits')
      const riskDocRef = doc(PolicyRef, auditID)

      const unsubscribe = onSnapshot(riskDocRef, (doc) => {
        if (doc.exists()) {
          const audit = doc.data()
          setFrameworks(audit.framework)
          setOwner(audit.auditor?.fullName)
          setStartDate(audit.start_date)
          setEndDate(audit.end_date)
          setAuditTitle(audit.auditTitle || '')
        }
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting risk:', error)
    }
  }

  useEffect(() => {
    const unsubscribe = getActiveFramworks()
    return () => unsubscribe && unsubscribe()
  }, [currentUser])

  useEffect(() => {
    const fetchCompanyData = async () => {
      if (currentUser?.tenantId) {
        const tenantRef = doc(db, 'tenants', currentUser.tenantId)
        const companyRef = doc(tenantRef, 'settings', 'company')
        const docSnap = await getDoc(companyRef)

        if (docSnap.exists()) {
          const companyData = docSnap.data()
          setOrganization(companyData.legalName || '')
        }
      }
    }

    fetchCompanyData()
  }, [currentUser])

  const getActiveFramworks = () => {
    const tenantId = currentUser?.tenantId || ''
    const tenantRef = doc(db, 'tenants', tenantId)
    const testsCollectionRef = collection(tenantRef, 'active_frameworks')

    const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
      const frameworksData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        frameworks: doc.data().frameworks,
      }))
      const frameworks = frameworksData[0]?.frameworks || []
      setActiveFrameworks(frameworks)
    })

    return unsubscribe
  }

  const handleFrameworkChange = (frameworks: string[]) => {
    setFrameworks(frameworks)

    if (frameworks.length === 0) {
      setFormErrors((prev) => ({...prev, frameworks: 'Please select at least one framework.'}))
    } else {
      setFormErrors((prev) => ({...prev, frameworks: ''}))
    }
  }

  const handleExportToDataroom = async () => {
    let errors = {...formErrors}
    let hasError = false

    // if (frameworks.length === 0) {
    //   errors.frameworks = 'Please select a framework.'
    //   hasError = true
    // } else {
    //   errors.frameworks = ''
    // }

    // if (!owner.trim()) {
    //   errors.owner = 'Please select an Auditor.'
    //   hasError = true
    // } else {
    //   errors.owner = ''
    // }

    // if (!auditTitle.trim()) {
    //   errors.auditTitle = 'Please enter an audit title.'
    //   hasError = true
    // } else {
    //   errors.auditTitle = ''
    // }

    // if (!organization.trim()) {
    //   errors.organization =
    //     'If no URL is available, please navigate to the settings page to upload the company details, which will then be displayed here.'
    //   hasError = true
    // } else {
    //   errors.organization = ''
    // }
    if (!startDate.trim()) {
      errors.startDate = 'Please select a start date.'
      hasError = true
    } else {
      errors.startDate = ''
    }

    if (!endDate.trim()) {
      errors.endDate = 'Please select an end date.'
      hasError = true
    } else {
      errors.endDate = ''
    }

    setFormErrors(errors)

    if (hasError) {
      return
    }

    setIsLoading(true)
    try {
      const currentDate = new Date()
      const year = currentDate.getFullYear()
      const month = String(currentDate.getMonth() + 1).padStart(2, '0')
      const day = String(currentDate.getDate()).padStart(2, '0')
      const formattedDate = `${year}-${month}-${day}`
      const todaysDate = `${month}/${day}/${year}`

      try {
        const tenantId = currentUser?.tenantId || ''
        const tenantRef = doc(db, 'tenants', tenantId)
        const riskRef = doc(tenantRef, 'audits', auditID)

        await updateDoc(riskRef, {
          updatedAt: formattedDate,
          start_date: startDate,
          auditStartDate: startDate,
          end_date: endDate,
          auditTitle: auditTitle,
        })
      } catch (frameworkError) {
        throw frameworkError
      }
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const activitiesRef = collection(tenantRef, 'activities')
      await addDoc(activitiesRef, {
        message: `${currentUser?.userName} updated a Audit date for ${frameworks} framework.`,
        timestamp: serverTimestamp(),
        tenantId: currentUser?.tenantId,
        uid: currentUser?.uid,
        username: currentUser?.userName,
        action: 'Audit updated',
        target: 'Audits',
        email: currentUser?.email,
        date: todaysDate,
      })
      showSuccessToast({message: 'Audit updated successfully'})
      onClose()
    } catch (error) {
      showErrorToast({message: 'Error updating audit'})
    } finally {
      setIsLoading(false)
      setFrameworks([])
      setOwner('')
      setStartDate('')
      setEndDate('')
      setAuditTitle('')
      setFormErrors({})
    }
  }

  return (
    <Drawer open={isOpen} onClose={onClose} direction='right' className='' size='45%'>
      <div
        className='modal-dialog-centered border-bottom border-gray-300'
        style={{
          position: 'sticky',
          top: 0,
          backgroundColor: 'white',
          padding: '14px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          paddingLeft: '15px',
          paddingRight: '12px',
        }}
      >
        <div className='fs-4 fw-bold mx-2' style={{margin: 0}}>
          {currentUser?.role === 'Auditor' ? 'Audit Details' : 'Edit Audit'}
        </div>
        <div style={{display: 'flex', gap: '16px'}}>
          <div
            className='btn btn-icon btn-sm btn-active-light-primary'
            onClick={onClose}
            aria-label='Close'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#5A5A5A'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-x'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M18 6l-12 12' />
              <path d='M6 6l12 12' />
            </svg>
          </div>
        </div>
      </div>
      <div
        className='p-6 scroll-y overflow-auto'
        tabIndex={-1}
        style={{height: 'calc(100vh - 50px)'}}
      >
        <div className='form-group w-100 mb-4'>
          <div className='my-2'>
            <label className='text-dark fw-semibold fs-6 required'>Frameworks</label>
          </div>
          <select
            className={`form-select mb-2 ${formErrors.frameworks ? 'is-invalid' : ''}`}
            value={frameworks}
            onChange={(e) => {
              const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value)
              handleFrameworkChange(selectedOptions)
            }}
            disabled
            style={{cursor: 'not-allowed'}}
          >
            <option value='' selected>
              Select framework
            </option>
            {activeFrameworks.map((framework) => (
              <option key={framework} value={framework}>
                {framework}
              </option>
            ))}
          </select>
          {formErrors.frameworks && <span className='text-danger'>{formErrors.frameworks}</span>}
        </div>
        <div className='form-group mb-4'>
          <Input
            type='text'
            label='Audit Title'
            value={auditTitle}
            placeholder='Audit title'
            maxLength={60}
            onChange={(e) => {
              setAuditTitle(e.target.value)
              setFormErrors((prev) => ({...prev, auditTitle: ''}))
            }}
            error={formErrors.auditTitle}
            disabled
            required
          />
          <div className='d-flex justify-content-between align-items-center mt-1'>
            {auditTitle.length > 40 && (
              <small className='text-warning'>
                {auditTitle.length >= 60
                  ? 'Character limit reached'
                  : 'Approaching character limit'}
              </small>
            )}
          </div>
        </div>
        {owner && (
          <div className='form-group mb-4'>
            <Input
              type='text'
              label='Auditor Name'
              value={owner}
              placeholder='Auditor Name'
              onChange={() => {}}
              error={formErrors.owner}
              disabled
              required
            />
          </div>
        )}
        <div className='form-group mb-4'>
          <Input
            type='text'
            label='Organization'
            value={organization}
            placeholder='Organization Name'
            onChange={(e) => {
              setOrganization(e.target.value)
              setFormErrors((prev) => ({...prev, organization: ''}))
            }}
            error={formErrors.organization}
            disabled
            required
          />
        </div>
        <div className='fv-row mb-4'>
          <Input
            type='date'
            label='Start Date'
            value={startDate}
            placeholder='Select start date'
            onChange={(e) => {
              setStartDate(e.target.value)
              setFormErrors((prev) => ({...prev, startDate: ''}))
            }}
            error={formErrors.startDate}
            required
            disabled={currentUser?.role === 'Auditor'}
          />
        </div>
        <div className='fv-row mb-4'>
          <Input
            type='date'
            label='End Date'
            value={endDate}
            placeholder='Select end date'
            onChange={(e) => {
              setEndDate(e.target.value)
              setFormErrors((prev) => ({...prev, endDate: ''}))
            }}
            error={formErrors.endDate}
            required
            disabled={currentUser?.role === 'Auditor'}
          />
        </div>
      </div>
      {currentUser?.role !== 'Auditor' && (
        <div
          className='offcanvas-footer d-flex justify-content-end border-top py-4 px-6'
          style={{position: 'sticky', bottom: 0, backgroundColor: 'white'}}
        >
          <button
            className='btn btn-sm btn-light fs-6 me-4'
            onClick={() => {
              setFrameworks([])
              onClose()
              setFormErrors({})
            }}
            style={{
              height: '40px',
              borderRadius: '4px',
              transition: 'background-color 0.3s',
            }}
          >
            Cancel
          </button>
          {isLoading ? (
            <button
              className='btn btn-sm fs-6'
              disabled
              style={{
                backgroundColor: '#0E9F6E',
                color: '#fff',
                height: '40px',
                borderRadius: '4px',
                transition: 'background-color 0.3s',
              }}
            >
              Updating... <span className='spinner-border spinner-border-sm align-middle'></span>
            </button>
          ) : (
            <button
              className='btn btn-sm fs-6'
              onClick={handleExportToDataroom}
              onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                (e.currentTarget.style.backgroundColor = '#148363')
              }
              onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                (e.currentTarget.style.backgroundColor = '#0E9F6E')
              }
              style={{
                backgroundColor: '#0E9F6E',
                color: '#fff',
                height: '40px',
                borderRadius: '4px',
                transition: 'background-color 0.3s',
              }}
            >
              Edit Audit
            </button>
          )}
        </div>
      )}
    </Drawer>
  )
}

export default EditAudit
